export interface DateModel {
    /** 1-31 */
    day: number;
    /** 0-11 */
    month: number;
    /** YYYY */
    year: number;
}

export const dateModelsEqual = (first: DateModel, second: DateModel) =>
    first.day === second.day && first.month === second.month && first.year === second.year;

export const dateModelToString = (date: DateModel) =>
    `${date.year.toString().padStart(4, '0')}-${(date.month + 1).toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`;

export const stringToDateModel = (date: string) => {
    const default_match = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/;
    let match = default_match.exec(date);

    let secondaryMatchUsed = false;
    if (!match) {
        match = getSecondaryMatch(date);
        secondaryMatchUsed = true;
    }

    if (!match) {
        return null;
    }

    const defaultDateModel = { year: +match[1], month: (+match[2]) - 1, day: +match[3] };
    const secondaryDateModel = { year: getYear(match[3]), month: (+ match[1]) - 1, day: +match[2] };
    return secondaryMatchUsed ? secondaryDateModel : defaultDateModel;

    function getSecondaryMatch(date: string) {
        secondaryMatchUsed = true;
        // min lenght of user input date is 8 (1/4/1992), max is 10 (01/04/1992)
        // allow user input without year
        if (date.length < 5) {
            const match = /^(\d{1,2})[ ./-]+(\d{1,2})/.exec(date);
            if (match) {
                match[3] = new Date().getFullYear().toString();
            }
            return match;
        }
        return /^(\d{1,2})[ ./-]+(\d{1,2})[ ./-]+(\d{0,4})(?:$|T)/.exec(date);
    }

    function getYear(year: string) {
        if (year.length === 2) {
            const firstTwoNumsOfCurrentYear = new Date().getFullYear().toString().slice(0, 2);
            return +`${firstTwoNumsOfCurrentYear + year}`;
        }
        if (year.length === 1) {
            const firstThreeNumsOfCurrentYear = new Date().getFullYear().toString().slice(0, 3);
            return +`${firstThreeNumsOfCurrentYear + year}`;
        }
        return +year;
    }
};
